import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-macro-dialog',
  templateUrl: './modal-macro-dialog.component.html',
  styleUrls: ['./modal-macro-dialog.component.css']
})
export class ModalMacroDialogComponent implements OnInit
{

  constructor(@Inject(MAT_DIALOG_DATA) public data: string[]) { }

  ngOnInit()
  {
  }

}
